// Lot 0 (CDC du 15/10, sécurité des comptes) : l'avis discret d'un compte dont l'adresse n'est pas
// encore confirmée, avec « Renvoyer le lien ». La confirmation n'est exigée que pour rejoindre un
// espace sans le lien d'une invitation : rien n'est bloqué ici, et l'avis se masque pour la session.
// N'ouvre rien : le serveur relit la vérification à chaque geste qui la demande.
import { useState } from 'react'
import axios from 'axios'

const API = (import.meta.env.VITE_API_URL || '') + '/api'
const CLE_MASQUE = 'terobs-avis-adresse-masque'

type Etat = 'repos' | 'envoi' | 'envoye' | 'erreur'

export function renvoyerLienDeConfirmation(): Promise<unknown> {
  return axios.post(`${API}/auth/verification-adresse/envoyer`)
}

/** Le bouton seul, pour l'écran d'une invitation en attente (LoginPage). */
export function BoutonRenvoyerLien({ className }: { className?: string }) {
  const [etat, setEtat] = useState<Etat>('repos')
  const envoyer = async () => {
    setEtat('envoi')
    try { await renvoyerLienDeConfirmation(); setEtat('envoye') } catch { setEtat('erreur') }
  }
  if (etat === 'envoye') {
    return <p className="text-sm text-(--c-text)" role="status">Lien envoyé : consultez votre boîte de réception.</p>
  }
  return (
    <>
      <button type="button" onClick={envoyer} disabled={etat === 'envoi'} className={className}>
        {etat === 'envoi' ? 'Envoi…' : 'Renvoyer le lien de confirmation'}
      </button>
      {etat === 'erreur' && (
        <p className="text-sm text-red-700" role="alert">L'envoi a échoué. Réessayez dans une minute.</p>
      )}
    </>
  )
}

export default function AvisAdresseNonVerifiee({ verifiee }: { verifiee: boolean | null | undefined }) {
  const [masque, setMasque] = useState<boolean>(() => {
    try { return sessionStorage.getItem(CLE_MASQUE) === '1' } catch { return false }
  })
  const [etat, setEtat] = useState<Etat>('repos')
  // `undefined` (session d'avant ce champ, ou compte d'environnement) : rien n'est affiché.
  if (verifiee !== false || masque) return null

  const envoyer = async () => {
    setEtat('envoi')
    try { await renvoyerLienDeConfirmation(); setEtat('envoye') } catch { setEtat('erreur') }
  }
  const masquer = () => {
    setMasque(true)
    try { sessionStorage.setItem(CLE_MASQUE, '1') } catch { /* navigation privée */ }
  }

  return (
    <div className="obs2-banner" role="note" style={{ marginBottom: 14, display: 'flex', gap: 12,
         alignItems: 'center', flexWrap: 'wrap' }}>
      <span style={{ flex: '1 1 260px' }}>
        {etat === 'envoye'
          ? 'Lien envoyé : ouvrez le courriel de confirmation (valable 48 heures).'
          : etat === 'erreur'
            ? "L'envoi a échoué. Réessayez dans une minute."
            : "Confirmez votre adresse électronique : c'est nécessaire pour rejoindre l'espace de votre collectivité."}
      </span>
      {etat !== 'envoye' && (
        <button type="button" className="obs2-btn obs2-btn-ghost" onClick={envoyer} disabled={etat === 'envoi'}>
          {etat === 'envoi' ? 'Envoi…' : 'Renvoyer le lien'}
        </button>
      )}
      <button type="button" className="obs2-btn obs2-btn-ghost" onClick={masquer} aria-label="Masquer cet avis">
        Plus tard
      </button>
    </div>
  )
}
